module.exports = __webpack_public_path__ + "static/toolkit-a0179b715e62959fea3c0a3bfbf4d89e.png";